import {
  CheckCircleOutlined,
  RightOutlined,
  EyeOutlined,
  CloseCircleOutlined,
  InboxOutlined,
  SearchOutlined,
  WarningOutlined,
  LockOutlined,
  FileSearchOutlined,
} from '@ant-design/icons'
import { Button, Menu, Dropdown, Modal, notification, Form, Input, Tooltip } from 'antd'
import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import '../../styleLess/signature/Taskdetail.scss'
import '../../styleLess/signature/new-status-styles.scss'
import { getCookie, setCookie } from 'helper/cookie'
import UpdateStatus from './Taskcomponents/UpdateStatus'
import CheckList from './Taskcomponents/CheckList'
import KPIfinanceTask from './Taskcomponents/KPIfinanceTask'
import SupportNeedTask from './Taskcomponents/SupportNeedTask'
import {
  getEventlogList,
  getSubTaskById,
  chooseTask,
  getListSubtask,
  onSendback,
  updateKeyActionStatus,
} from 'api/TaskInbox/taskInboxapi'
import { getProjectById } from 'api/Project/project'
import { useParams } from 'react-router-dom'
import { getDataListCheckList } from 'api/TaskInbox/checklist'
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import { getauthorityUser, getPermissionSprintflow } from 'api/Account/permission'
import { getKpiSearch } from 'api/Project/kpifinance'
import { getResultSupportNeed } from 'api/Project/supportneed'
import lang from 'lang/en'
import { Row } from 'antd'
import { CounterContext } from 'redux/Golbalvalues'
import { IconModalDependency } from 'common/SVG/svg.common'
import WaitingOnModalCommon from 'common/Dependencies/Modal/modal.waitingOn'
import BockingModalCommon from 'common/Dependencies/Modal/modal.bocking'
import TasksModalCommon from 'common/Dependencies/Modal/modal.tasks'
import renderIconDependency from 'common/Dependencies/RenderIconDependency/renderIconDependency'
const { TextArea } = Input
const TextHover = styled.p`
  cursor: pointer;
  color: #074e9f;
  &:hover {
    color: #0a6ee1;
  }
`
const Container = styled.div`
  // background-color: #af2;
  height: 100%;
`

const Headder = styled.div``
const Body = styled.div``
const Useractivity = styled.div``
const initialState = {
  data: [],
  isLoading: true,
  visibleModal: false,
  btn: true,
}
let flow_status = ''
let planDate = {}
let headStatusLog = ''
let reasonLog = ''
const Taskinboxdetail = () => {
  // from history
  let url_page = window.location.pathname
  let current_path = url_page.split('/')
  const [Focustab, setFocustab] = useState(true)
  const [OneFocus, SetOneFocus] = useState(1)
  const [data, setData] = useState(initialState.data)
  const [dataProject, setDataProject] = useState(initialState.data)
  const [isLoading, setIsLoading] = useState(initialState.isLoading)
  const [dataCheckList, setDataCheckList] = useState(initialState.data)
  const [eventList, setEventLit] = useState(initialState.data)
  const [hidden, setHidden] = useState(true)
  const [disable, setDisable] = useState(true)

  const [percent, SetPercent] = useState()
  const [roleIdauthority, setRoleIdauthority] = useState(initialState.data)
  const history = useHistory()
  const [visibleModalInformation, setVisibleModalInformation] = useState(
    initialState.visibleModal,
  )
  const [visibleModalActivity, setVisibleModalActivity] = useState(
    initialState.visibleModal,
  )
  const [disbleDone, setDisbleDone] = useState(initialState.btn)
  const [showDone, setShowDone] = useState()
  const [checkActualGoal, setCheckActualGoal] = useState(true)
  const [checkSendMail, setCheckSendMail] = useState(true)
  const [loadingBtnDone, setLoadingBtnDone] = useState(true)
  const [visibleModalDone, setVisibleModalDone] = useState(false)
  const [visibleModalDependencies, setVisibleModalDependencies] = useState(false)
  const [waitingErrorInModal, setWaitingErrorInModal] = useState([])
  const [checkSubtaskDone, setCheckSubtaskDone] = useState(true)
  const [approve, setApprove] = useState(false)
  const token = getCookie('access_token_admin')
  const [statusMap, setStatusMap] = useState(false)
  const [checkLanding, setCheckLanding] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [dataKPIFinance, setDataKPIFinance] = useState(initialState.data)
  const [dataSupportNeed, setDataSupportNeed] = useState(initialState.data)
  const { project_id, subtaskId } = useParams()
  const language = getCookie('lang')
  const word = lang[language]
  const useChangStatus = (status) => {
    setStatusMap(status)
  }
  const { mainRoleUser, adminPermission, setPathActive, pathActive } = useContext(
    CounterContext,
  )
  const [permissionPage, setPermissionPage] = useState({
    menu_id: 0,
    create: false,
    read: false,
    update: false,
    delete: false,
  })
  const [isOpenModalDependencies, setIsOpenModalDependencies] = useState(false)
  const [dataModalDependencies, setDataModalDependencies] = useState([])
  const sprintflowPermissionName = (data?.permission_name || '').trim()
  const canCompleteAllTasks = mainRoleUser == 1

  useEffect(() => {
    if (mainRoleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        menu_id: 5,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 5 || item.menu_id == 4) {
          setPermissionPage((prevState) => ({
            ...prevState,
            menu_id: item.menu_id,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])
  ////    call api subtask by id
  const getDataSubTask = async () => {
    const data = {
      id: subtaskId,
      project_id: project_id,
    }
    await getSubTaskById({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setData([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          flow_status = data.flow_status
          const permissionName = (data.permission_name || '').trim()
          await setData(data)
          await setIsLoading(false)
          if (data.flow_status === 'Complete') {
            setShowDone(false)
          } else {
            setShowDone(true)
          }
          // hidden true : แก้ไขไม่ได้,  false : แก้ไขได้
          if (canCompleteAllTasks) {
            setHidden(false)
            setDisable(false)
          } else if (permissionName === 'Contributor') {
            setHidden(false)
            setDisable(true)
          } else if (permissionPage.menu_id === 5 && permissionPage.update) {
            setHidden(false)
            setDisable(false)
          } else if (permissionPage.update) {
            // if (data.cando === 'N') {
            // setHidden(true)
            // }
            setDisable(false)
            if (!['On time', 'Not start'].includes(data.flow_status) || data.permission_id !== 5) {
              // can not edit detail
              setHidden(true)
            } else {
              // can edit detail
              setHidden(false)
            }
          } else {
            setHidden(true)
          }
        } else {
          setData([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setData([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResultListSubtask = async () => {
    const data = {
      id: project_id,
      subtask_id: subtaskId,
    }
    await getListSubtask({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setCheckSubtaskDone(true)
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setIsLoading(false)
          data.map((subtask) => {
            if (!['Complete'].includes(subtask.flow_status)) {
              setCheckSubtaskDone(false)
            }
          })
        } else {
          setCheckSubtaskDone(true)
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setCheckSubtaskDone(true)
        setIsLoading(false)
        console.error(error)
      })
  }

  const getroleAuthority = async () => {
    await getauthorityUser({
      id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setRoleIdauthority([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setRoleIdauthority(data)
          await setIsLoading(false)
        } else {
          setRoleIdauthority([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setRoleIdauthority([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getRolePermissionSprintflow = async () => {
    await getPermissionSprintflow({
      project_id: project_id,
      sprintflow_id: subtaskId,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setIsLoading(false)
        } else {
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setIsLoading(false)
        console.error(error)
      })
  }

  const getLogList = async () => {
    const data = {
      project_id: parseInt(project_id),
      sprintflow_id: parseInt(subtaskId),
    }
    await getEventlogList({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setEventLit([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setEventLit(data)
          await setIsLoading(false)
          getDataSubTask()
          getCheckList()
        } else {
          setEventLit([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setEventLit([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getDataProject = async () => {
    await getProjectById({
      id: project_id,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataProject([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          setCookie('companyId_project', data.company_id)
          planDate = {
            kickoff: data.kickoff,
            closure: data.closure,
          }
          await setDataProject(data)
          await setIsLoading(false)
        } else {
          setDataProject([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataProject([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResultKpi = async (state) => {
    // เข็ค done โดนเข็คจาก actual goal และ send mail support need
    setCheckActualGoal(true)
    setLoadingBtnDone(true)
    const data = {
      project_id: project_id,
      sprintflow_id: subtaskId,
    }
    getKpiSearch({
      params: data,
      token: token,
    })
      .then(async (response) => {
        setDataKPIFinance([])
        const { status, data, error } = response
        if (error) {
          await setDataKPIFinance([])
          setIsLoading(false)
          setLoadingBtnDone(false)
          return true
        }
        if (status === 200) {
          if (![undefined, null, ''].includes(data.projects)) {
            data.projects.map((item) => {
              if ([0].includes(item.actual_goal)) {
                setCheckActualGoal(false)
              }
              const addTypeItem = {
                ...item,
                section: 'of project',
              }
              setDataKPIFinance((prevData) => [...prevData, addTypeItem])
            })
          }
          if (![undefined, null, ''].includes(data.tasks)) {
            data.tasks.map((item) => {
              if ([0].includes(item.actual_goal)) {
                setCheckActualGoal(false)
              }
              const addTypeItem = {
                ...item,
                section: 'of task',
              }
              setDataKPIFinance((prevData) => [...prevData, addTypeItem])
            })
          }
          if (![undefined, null, ''].includes(data.subtasks)) {
            data.subtasks.map((item) => {
              if ([0].includes(item.actual_goal)) {
                setCheckActualGoal(false)
                const addTypeItem = {
                  ...item,
                  section: 'of subtask',
                }
                setDataKPIFinance((prevData) => [...prevData, addTypeItem])
              }
            })
          }
          await setIsLoading(false)
          await setLoadingBtnDone(false)
        } else {
          setDataKPIFinance([])
          setIsLoading(false)
          setLoadingBtnDone(false)
          return true
        }
      })
      .catch((error) => {
        setDataKPIFinance([])
        setIsLoading(false)
        setLoadingBtnDone(false)
        console.error(error)
      })
  }

  const getSupportNeed = async () => {
    setCheckSendMail(true)
    getResultSupportNeed({
      project_id: project_id,
      sprintflow_id: subtaskId,
      taskinbox: 'Y',
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataSupportNeed([])
          return true
        }
        if (status === 200) {
          data.map((item) => {
            if (['N'].includes(item.sendmail_status)) {
              setCheckSendMail(false)
            }
          })
          await setDataSupportNeed(data)
          setIsLoading(false)
        } else {
          setDataSupportNeed([])
          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataSupportNeed([])
        console.error(error)
      })
  }

  const getCheckList = async () => {
    const data = {
      project_id: project_id,
      sprintflow_id: subtaskId,
    }
    await getDataListCheckList({
      params: data,
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setDataCheckList([])

          await setIsLoading(false)
          return true
        }
        if (status === 200) {
          await setDataCheckList(data.datalist)
          await SetPercent(data.percent)
          await setIsLoading(false)
          if (data.percent === 100) {
            setDisbleDone(false)
          } else {
            setDisbleDone(true)
          }
        } else {
          setDataCheckList([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCheckList([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const handleFocus = (focus, url) => {
    SetOneFocus(focus)
    setFocustab(true)
    current_path[1] === 'historyInbox'
      ? history.push(`/historyInbox/${project_id}/${subtaskId}/${url}`)
      : history.push(`/taskinbox/${project_id}/${subtaskId}/${url}`)
    return setSwitchComponents(url)
  }

  const handleApproveWarning = () => {
    setVisibleModalDone(true)
    setApprove(true)
  }

  const handleApproveReject = (value, type) => {
    if (type === 'Approve') {
      const data = {
        sprintflow_id: parseInt(subtaskId),
        project_id: parseInt(project_id),
        choose_way: 'Approve',
      }
      try {
        chooseTask({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            openNotificationWithIcon('success', 'You have been approved.')
            getDataSubTask()
            getLogList()
          }
        })
      } catch (error) {
        console.log(error)
      }
      setVisibleModalDone(false)
      setApprove(false)
    } else {
      const data = {
        sprintflow_id: parseInt(subtaskId),
        project_id: parseInt(project_id),
        remark: value.choise_reject,
        choose_way: 'Reject',
      }
      try {
        chooseTask({
          params: data,
          token: token,
        }).then((res) => {
          if (res.status === 200) {
            openNotificationWithIcon('warning', 'You have been rejected.')
            getDataSubTask()
            getLogList()
          }
        })
      } catch (error) {
        console.log(error)
      }
      setVisibleReject(false)
    }
  }

  const openNotificationWithIcon = (type, des) => {
    notification[type]({
      description: des,
      duration: 2,
    })
  }

  const handlerDone = () => {
    setVisibleModalDone(true)
  }

  const submitDone = () => {
    const payload = {
      id: parseInt(subtaskId),
      status: 'complete',
      level: data.level,
    }
    try {
      updateKeyActionStatus({
        data: payload,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getDataSubTask()
          openNotificationWithIcon('success', 'You have been done.')
          getLogList()
        } else if (res.status === 400) {
          setWaitingErrorInModal(res.data || []), setVisibleModalDependencies(true)
        }
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleModalDone(false)
  }

  const modalWarningDone = () => {
    return (
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleModalDone}
        onOk={approve ? (e) => handleApproveReject(e, 'Approve') : submitDone}
        okText={'Done'}
        onCancel={onCancel}
      >
        <WarningOutlined className="exclamationCircleOutlined" />
        <h2> {word['warning_done_title']}</h2>
        <h4 style={{ textAlign: 'center' }}>
          {!checkActualGoal && checkSendMail ? (
            <>{word['warning_actual_done_des']}</>
          ) : !checkSendMail && checkActualGoal ? (
            <>{word['warning_mail_done_des']}</>
          ) : !checkSendMail && !checkActualGoal ? (
            <>{word['warning_done_des']}</>
          ) : (
            <>
              <h4 style={{ margin: 0 }}> {word['done_task_title']}</h4>
              <h4 style={{ margin: 0 }}>{word['done_task_des']}</h4>
            </>
          )}
        </h4>
      </Modal>
    )
  }

  const [visibleReview, setVisibleReview] = useState()
  const [form_review] = Form.useForm()
  const modalReview = () => {
    return (
      <Modal
        maskClosable={false}
        className="ModalStatusOption"
        visible={visibleReview}
        okText={'OK'}
        onOk={form_review.submit}
        onCancel={() => setVisibleReview(false)}
        cancelText={'Cancel'}
        destroyOnClose
      >
        <Form
          className="body-form"
          form={form_review}
          onFinish={handleSendback}
          name="form_review"
        >
          <CheckCircleOutlined className="Icon-style" />
          <h2>{word['Review_task']}</h2>
          <h4>{word['Are_you_sure_you_want_to_review']}</h4>
          <Form.Item
            className="subform"
            id="reason"
            name="reason"
            rules={[
              {
                whitespace: true,
                required: true,
                message: '* Please tell a reason',
              },
            ]}
          >
            <TextArea
              id="reason"
              name="reason"
              placeholder="Please tell a reason"
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
        </Form>
      </Modal>
    )
  }

  const onCancel = () => {
    setVisibleModalDone(false)
    setApprove(false)
  }
  const goTaskinbox = () => {
    history.push({
      pathname: '/taskinbox',
    })
  }
  const goOverview = (id) => {
    history.push({
      pathname: `/overview/${id}`,
    })
  }
  const urlPage = window.location.href
  const checkLandingPage = () => {
    const split = urlPage.split('/')
    let landing = ''
    if (split[6]) {
      landing = split[6]
      if (landing === 'update') {
        SetOneFocus(1)
        setFocustab(true)
        return setSwitchComponents('update')
      } else if (landing === 'checklist') {
        SetOneFocus(2)
        setFocustab(true)
        return setSwitchComponents('checklist')
      } else if (landing === 'kpi') {
        SetOneFocus(3)
        setFocustab(true)
        return setSwitchComponents('kpi')
      } else if (landing === 'kpi') {
        SetCurrent(3)
        setFocus(3)
        return setSwitchComponents('kpi')
      } else if (landing === 'supportneed') {
        SetOneFocus(4)
        setFocustab(true)
        return setSwitchComponents('supportneed')
      }
      setCheckLanding(true)
    }
  }
  useEffect(() => {
    if (token && permissionPage.menu_id != 0) {
      window.scrollTo(0, 0)
      getDataSubTask()
      getDataProject()
      getCheckList()
      getLogList()
      getroleAuthority()
      getRolePermissionSprintflow()
      getResultListSubtask()
      getResultKpi()
      getSupportNeed()
    }
  }, [token, permissionPage])
  useEffect(() => {
    if (checkLanding === false) {
      checkLandingPage()
    }
  }, [urlPage])
  useEffect(() => {
    if (token) {
      setPathActive('/taskinbox')
    }
  }, [token])
  useEffect(() => {
    if (data?.id) {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: 'open_task_inbox',
        item_id: subtaskId,
        user_id: getCookie('userID'),
      })
    }
  }, [data?.id])

  const [switchComponents, setSwitchComponents] = useState('')
  // console.log(data)
  const renderComponents = (value) => {
    switch (switchComponents) {
      case 'checklist':
        return (
          <CheckList
            useChangStatus={(e) => useChangStatus(e)}
            statusMap={statusMap}
            dataCheckList={dataCheckList}
            percent={percent}
            getCheckList={getCheckList}
            getLogList={getLogList}
            flow_status={flow_status}
            hidden={hidden}
          />
        )
      case 'kpi':
        return (
          <KPIfinanceTask
            hidden={hidden}
            getLogList={getLogList}
            dataKPIFinance={dataKPIFinance}
            getResultKpi={getResultKpi}
            loadingBtnDone={loadingBtnDone}
            taskLevel={data.level}
          />
        )
      case 'supportneed':
        return (
          <SupportNeedTask
            projectId={dataProject.id != null ? dataProject.id : project_id}
            subtaskId={subtaskId}
            authorityId={roleIdauthority.role_id}
            hidden={hidden}
            getLogList={getLogList}
            dataSupportNeed={dataSupportNeed}
            getSupportNeed={getSupportNeed}
          />
        )
      default:
        return (
          <UpdateStatus
            getLogList={getLogList}
            planDate={planDate}
            hidden={hidden}
            duration={dataProject.duration_id}
            planStartDate={data.plan_start}
            planEndDate={data.plan_end}
            working_hour={data.working_hour}
          />
        )
    }
  }
  const menu = (data) => {
    return (
      <Menu style={{ width: 140 }}>
        <Menu.Item key="0" onClick={() => setVisibleModalInformation(true)}>
          Task Information
        </Menu.Item>
        <Menu.Item key="1" onClick={() => setVisibleModalActivity(true)}>
          Task Activity
        </Menu.Item>
      </Menu>
    )
  }
  const handleCancel = () => {
    setVisibleModalInformation(false)
    setVisibleModalActivity(false)
  }
  const reasonLogActivity = (item) => {
    let array = []
    headStatusLog = item.message.split(' ')
    headStatusLog.map((message, index) => {
      if (index !== 0) {
        array.push(message)
      }
    })
    reasonLog = array.join(' ')
  }
  const messageLogActivity = (item) => {
    const dataDate = item.updated_at
    const date = new Date(dataDate)

    // format the time using Intl.DateTimeFormat
    const formattedTime = new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    }).format(date)

    // combine the formatted date and time strings
    const formattedDateTime = `${moment(dataDate).format('DD/MM/YYYY')} ${formattedTime}`

    return (
      <div className="right-z">
        {headStatusLog[0] === 'Reject' ? (
          <div>
            <Row>
              <p>
                {item.firstname} {item.lastname}
              </p>
              <p className="text-reason-reject">{headStatusLog[0]}</p>
              <p style={{ marginLeft: 4 }}>task</p>
            </Row>
            <text className="head-reason-reject">
              reason: <text className="sub-reason">{reasonLog}</text>
            </text>
          </div>
        ) : (
          <p>
            {item.firstname} {item.lastname} {item.message}
          </p>
        )}
        <div className="small text-color">{`${item.dayago} ${formattedDateTime}`}</div>
      </div>
    )
  }

  const activityRenderBy = () => {
    if (eventList.length == 0) {
      return (
        <div className="emytystate">
          <InboxOutlined className="inbox" />
          <p>No Activity</p>
        </div>
      )
    } else {
      return eventList
        .filter((result) => {
          if (searchTerm == '') {
            return result
          } else if (result.message.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (result.updated_at.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (result.firstname.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (result.lastname.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (
            result.firstname_th.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return result
          } else if (
            result.lastname_th.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return result
          }
        })
        .map((item) => {
          reasonLogActivity(item)
          return (
            <div className="Styles-Activity">
              <div className="left-z">
                <img className="imageStyle" src={item.pic_display}></img>
              </div>
              {messageLogActivity(item)}
            </div>
          )
        })
    }
  }
  const activityRenderBy_modal = () => {
    if (eventList.length == 0) {
      return (
        <div className="emytystate">
          <InboxOutlined className="inbox" />
          <p>No Activity</p>
        </div>
      )
    } else {
      return eventList
        .filter((result) => {
          if (searchTerm == '') {
            return result
          } else if (result.message.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (result.updated_at.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (result.firstname.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (result.lastname.toLowerCase().includes(searchTerm.toLowerCase())) {
            return result
          } else if (
            result.firstname_th.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return result
          } else if (
            result.lastname_th.toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return result
          }
        })
        .map((item) => {
          reasonLogActivity(item)
          return (
            <div className="detail">
              <div className="left-z">
                <img className="imageStyle" src={item.pic_display}></img>
              </div>
              {messageLogActivity(item)}
            </div>
          )
        })
    }
  }
  const [visibleReject, setVisibleReject] = useState(false)
  const [form] = Form.useForm()
  const modalReject = () => {
    return (
      <Modal
        maskClosable={false}
        className="DeleteModal"
        visible={visibleReject}
        okText={'Reject'}
        onOk={form.submit}
        onCancel={() => setVisibleReject(false)}
        destroyOnClose
      >
        <Form
          className="body-form"
          form={form}
          onFinish={(e) => handleApproveReject(e)}
          name="form"
        >
          <CloseCircleOutlined className="CloseCircleOutlined" />
          <h2>{word['choise_reject_title']}</h2>
          <h4>{word['choise_reject_des']}</h4>
          <Form.Item
            className="subform"
            id="choise_reject"
            name="choise_reject"
            rules={[
              {
                whitespace: true,
                required: true,
                message: '*Please tell a reason.',
              },
            ]}
          >
            <TextArea
              id="reason_reject"
              name="reason_reject"
              placeholder="Please tell a reason."
              autoSize={{ minRows: 1, maxRows: 4 }}
            />
          </Form.Item>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              flexDirection: 'row',
              width: '100%',
            }}
          >
            <span style={{ color: '#ff0000' }}>*</span>
            <span className="small">
              {!checkActualGoal && checkSendMail ? (
                <>{word['warning_actual_done_des']}</>
              ) : !checkSendMail && checkActualGoal ? (
                <>{word['warning_mail_done_des']}</>
              ) : !checkSendMail && !checkActualGoal ? (
                <>{word['warning_done_des']}</>
              ) : (
                <>
                  {word['done_task_title']}
                  {word['done_task_des']}
                </>
              )}
            </span>
          </div>
        </Form>
      </Modal>
    )
  }

  const handleClickReject = () => {
    setVisibleReject(true)
    form.setFieldsValue({
      choise_reject: null,
    })
  }
  const handleSendback = (val) => {
    // subtaskId = id ของตัว task นั้นเอง
    const data = {
      project_id: parseInt(project_id),
      sprintflow_id: parseInt(subtaskId),
      remark: val.reason,
    }
    try {
      onSendback({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          getDataSubTask()
          getLogList()
        }
      })
    } catch (error) {
      console.log(error)
    }
    setVisibleReview(false)
  }
  const ButtonReview = () => {
    return data.sendback == 'Y' ? (
      <Button
        id="btn_review"
        type="primary"
        className="btn_Secondary2"
        hidden={!hidden && !loadingBtnDone ? false : true}
        disabled={data.candone == 'Y' && showDone ? false : true}
        onClick={() => {
          setVisibleReview(true),
            form_review.setFieldsValue({
              reason: null,
            })
        }}
      >
        <FileSearchOutlined className="Icon-color" />
        Review
      </Button>
    ) : (
      _
    )
  }
  const btnChoice = () => {
    if (data.shape_chart === 'flow-rhombus') {
      return (
        <btnChoice className="btn-Choise">
          {ButtonReview()}
          <Button
            id="btn_reject"
            className="btn_Secondary2"
            disabled={
              disbleDone ||
                !checkSubtaskDone ||
                (data.sendback == 'Y' && data.candone == 'N')
                ? true
                : false
            }
            hidden={showDone && !hidden && !loadingBtnDone ? false : true}
            onClick={(e) => handleClickReject(e, 'reject')}
            style={{ marginLeft: 8 }}
          >
            <CloseCircleOutlined className="Icon-color" />
            Reject
          </Button>
          <Button
            id="btn_approve"
            type="primary"
            className="BTN_Next"
            disabled={
              disbleDone ||
                !checkSubtaskDone ||
                (data.sendback == 'Y' && data.candone == 'N')
                ? true
                : false
            }
            hidden={showDone && !hidden && !loadingBtnDone ? false : true}
            style={{ marginLeft: 8 }}
            onClick={handleApproveWarning}
          >
            <CheckCircleOutlined className="Icon-color" />
            Approve
          </Button>
          {modalReject()}
        </btnChoice>
      )
    } else {
      return (
        <Row>
          {ButtonReview()}
          {
            // check disable
            disbleDone ||
              !checkSubtaskDone ||
              (data.sendback == 'Y' && data.candone == 'N') ||
              (!canCompleteAllTasks && sprintflowPermissionName === 'Contributor') ? (
              <Tooltip
                title={!checkSubtaskDone ? word['tooltip_btn_done'] : undefined}
                placement="topLeft"
              >
                <span>
                  <div style={{ cursor: 'no-drop' }}>
                    <Button
                      id="btn_done"
                      type="primary"
                      style={{ marginLeft: 8, pointerEvents: 'none' }}
                      className="BTN_Next DoneBtn"
                      disabled
                      onClick={handlerDone}
                      hidden={showDone && !hidden && !loadingBtnDone ? false : true}
                    >
                      <CheckCircleOutlined className="Icon-color" />
                      Complete
                    </Button>
                  </div>
                </span>
              </Tooltip>
            ) : (
              <Button
                id="btn_done"
                type="primary"
                style={{ marginLeft: 8 }}
                className="BTN_Next DoneBtn"
                disabled={disable}
                onClick={handlerDone}
                hidden={showDone && !hidden && !loadingBtnDone ? false : true}
              >
                <CheckCircleOutlined className="Icon-color" />
                Complete
              </Button>
            )
          }
        </Row>
      )
    }
  }
  const onChangeSearch = (e) => {
    setSearchTerm(e.target.value)
  }
  const DetailTask = (projectId, taskId) => {
    history.push({
      pathname: `/taskinbox/${projectId}/${taskId}/update`,
    }),
      window.location.reload()
  }

  const renderWaitingInModal = () => {
    return waitingErrorInModal?.map((item) => (
      <div
        className="group-render-waiting"
        onClick={() => DetailTask(item?.project_id, item?.sprintflow_id)}
      >
        <div className="dot" /> {item?.title}
      </div>
    ))
  }

  const modalDependencies = () => {
    return (
      <div className="modal-dependencies">
        <div className="header-modal">Dependencies</div>
        <div className="project-id-style">
          <div className="text">{dataModalDependencies?.code}</div>
          <div
            className={`Status  ${dataModalDependencies?.flow_status === 'Not start'
              ? 'status-not-start'
              : dataModalDependencies?.flow_status === 'On time'
                ? 'status-on-time'
                : dataModalDependencies?.flow_status === 'Delay'
                  ? 'status-delay'
                  : dataModalDependencies?.flow_status === 'On hold'
                    ? 'status-on-hold'
                    : dataModalDependencies?.flow_status === 'Complete'
                      ? 'status-complete'
                      : 'status-default'
              }`}
            style={{ minWidth: 'fit-content' }}
          >
            <span className="smallStatus ">{dataModalDependencies?.flow_status}</span>
          </div>
        </div>
        <div className="project-name-style">{dataModalDependencies?.title}</div>
        <WaitingOnModalCommon dataTasks={dataModalDependencies?.waiting_on || []} />
        <BockingModalCommon dataTasks={dataModalDependencies?.blocking || []} />
        <TasksModalCommon dataTasks={dataModalDependencies?.tasks || []} />
      </div>
    )
  }

  const dataDependencies = {
    ...data,
    project_id: project_id,
    id: subtaskId,
  }

  return (
    <Container style={{ borderRadius: '8px' }}>
      <Headder className="responsive-header">
        <div className="class-h1">
          {current_path[1] === 'historyInbox' ? (
            <h4 className="h4-color1" onClick={() => history.push('/historyInbox')}>
              History
            </h4>
          ) : (
            <h4 className="h4-color1" onClick={goTaskinbox}>
              Task Inbox
            </h4>
          )}

          <RightOutlined className="icon-color" />
          <h4 className="h4-color2" onClick={goTaskinbox}>
            {data.code}
          </h4>
          <div
            className={`Status  ${data.flow_status === 'Not start'
              ? 'status-not-start'
              : data.flow_status === 'On time'
                ? 'status-on-time'
                : data.flow_status === 'Delay'
                  ? 'status-delay'
                  : data.flow_status === 'On hold'
                    ? 'status-on-hold'
                    : data.flow_status === 'Complete'
                      ? 'status-complete'
                      : 'status-default'
              }`}
          >
            {data.flow_status}
          </div>
        </div>
        <div className="class-h2">
          <div className="class-h2-left">
            <h1 className="no-breadcrumb">{data.title}</h1>
            {/* <Tooltip title={'Waiting for approval decision task'}>
              <ExclamationCircleOutlined
                hidden={data?.cando === 'N' ? false : true}
                className='exclamation-icon'
              />
            </Tooltip> */}
          </div>

          <div className="responsive" style={{ display: 'flex' }}>
            <Dropdown
              overlay={(e) => menu()}
              trigger={['click']}
              placement="bottomCenter"
            >
              <Button
                id="btn_viewDetail"
                className="btn_Secondary2 btn-responsive"
                type="primary"
                disabled={false}
                hidden={permissionPage.read ? false : true}
              >
                <EyeOutlined className="Icon-color" />
                View Detail
              </Button>
            </Dropdown>
            <div hidden={permissionPage.update ? false : true}> {btnChoice()}</div>
          </div>
        </div>
      </Headder>
      <Body>
        <div className="ContainerMaster">
          <div className="Left-Container">
            {permissionPage.read === true ? (
              <div className="row1">
                <div className="marginbottom">
                  <h3 className="ContentName">Task Information</h3>
                  <p className="text-color">{data?.code}</p>
                  <h3 style={{ display: 'flex', marginTop: '10px' }}>
                    {data?.title}
                    {renderIconDependency(
                      dataDependencies,
                      setIsOpenModalDependencies,
                      setDataModalDependencies,
                    )}
                  </h3>

                  <p className="text-color description-minheight">{data.description}</p>
                </div>
                <div>
                  <div className="inline-div1">
                    <p>Project</p>
                    <TextHover
                      onClick={() => {
                        goOverview(dataProject.id)
                      }}
                      className="cutter-text-line-1"
                    >
                      {dataProject.name}
                    </TextHover>
                  </div>
                  <div className="line-horizonspace"></div>
                  <div className="inline-div1">
                    <p>Date</p>
                    <p className="text-color">
                      {moment(data.plan_start).format('DD MMM YYYY')} -{' '}
                      {moment(data.plan_end).format('DD MMM YYYY')}
                    </p>
                  </div>
                  <div className="line-horizonspace"></div>
                  <div className="inline-div1">
                    <p>Working day</p>
                    <p className="text-color">{data.working}</p>
                  </div>
                  <div className="line-horizonspace"></div>
                  <div className="inline-div1">
                    <p>Working hr/day</p>
                    <p className="text-color">{data.working_hour}</p>
                  </div>
                </div>
              </div>
            ) : (
              <div className="row1 reset-row ">
                <h3 className="ContentName">Task Information</h3>
                <div className="otherstate-perm perm-minheight">
                  <LockOutlined className="lock-permission-icon" />
                  <h2 className="lock-permission-text">No Permission</h2>
                </div>
              </div>
            )}

            <div className="row2">
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  flexWrap: 'nowrap',
                }}
              >
                <h3 className="Contentname">Task Activity</h3>
                <div hidden={permissionPage.read ? false : true}>
                  <Tooltip title="Search action, name or date (YYYY-MM-DD)">
                    <Input
                      className={eventList.length > 0 ? 'search-log' : 'search-log-none'}
                      prefix={<SearchOutlined />}
                      value={searchTerm}
                      onChange={onChangeSearch}
                      placeholder="Search action, name or date (YYYY-MM-DD)"
                      type="text"
                      size="small"
                      allowClear
                    />
                  </Tooltip>
                </div>
              </div>
              {permissionPage.read === true ? (
                <Useractivity className="Useractivity">{activityRenderBy()}</Useractivity>
              ) : (
                <Useractivity className="Useractivity otherstate-perm">
                  <LockOutlined className="lock-permission-icon" />
                  <h2 className="lock-permission-text">No Permission</h2>
                </Useractivity>
              )}
            </div>
          </div>
          <div className="Right-Container">
            <div className="overflow-tab">
              <div className="tab">
                <div
                  className={Focustab && OneFocus == 1 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleFocus(1, 'update')}
                >
                  <h3>Update status</h3>
                </div>
                <div
                  className={Focustab && OneFocus == 3 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleFocus(3, 'kpi')}
                >
                  <h3>KPI/Finance</h3>
                </div>
                <div
                  className={Focustab && OneFocus == 2 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleFocus(2, 'checklist')}
                >
                  <h3>Check list</h3>
                </div>
                <div
                  className={Focustab && OneFocus == 4 ? 'Tabbar' : 'active-Tabbar'}
                  onClick={() => handleFocus(4, 'supportneed')}
                >
                  <h3>Support need</h3>
                </div>
              </div>
            </div>
            {permissionPage.read === true ? (
              <div className="components-style-taskdetail">{renderComponents()}</div>
            ) : (
              <div className="components-style-taskdetail otherstate-perm">
                <LockOutlined className="lock-permission-icon" />
                <h2 className="lock-permission-text">No Permission</h2>
              </div>
            )}
          </div>
        </div>
      </Body>
      {modalWarningDone()}
      <Modal
        visible={visibleModalDependencies}
        onCancel={() => setVisibleModalDependencies(false)}
        footer={false}
        centered
        width={602}
      >
        <ContainerInModalDependencies>
          <div className="icon-leyout">
            <IconModalDependency />
          </div>
          <div className="text-title">Dependency Warning</div>
          <div className="text-discraption">
            This task is waiting on another task to be completed. Are you sure you want to
            change the status of this task?
          </div>
          <div className="text-waitting">WAITING ON</div>
          {renderWaitingInModal()}
        </ContainerInModalDependencies>
      </Modal>
      <Modal
        maskClosable={false}
        className="modalNoBtn information-modal"
        visible={visibleModalInformation}
        onCancel={handleCancel}
      >
        <div className="containerResponsModalTaskInformation">
          <div className="row1">
            <h2 className="no-breadcrumb">Task Information</h2>
            <p className="code">{data.code}</p>
            <h3 className="name">{data.title}</h3>
            <p className="description ">{dataProject.description}</p>
          </div>
          <div className="row2">
            <div className="inline">
              <p>Project</p>
              <div style={{ display: 'grid' }}>
                <a
                  className={'cutter-text-line-1'}
                  style={{ cursor: 'pointer' }}
                  onClick={() => {
                    goOverview(dataProject.id)
                  }}
                >
                  {dataProject.name}
                </a>
              </div>
            </div>
            <div className="line-horizonspace"></div>
            <div className="inline">
              <p>Date</p>
              <p className="text-date">
                {moment(data.plan_start).format('DD MMM YYYY')}-
                {moment(data.plan_end).format('DD MMM YYYY')}
              </p>
            </div>
            <div className="line-horizonspace"></div>
            <div className="inline">
              <p>Working day</p>
              <p className="text-date">{data.working}</p>
            </div>
            <div className="line-horizonspace"></div>
            <div className="inline">
              <p>Working hr/day</p>
              <p className="text-date">{data.working_hour}</p>
            </div>
          </div>
        </div>
      </Modal>
      <Modal
        maskClosable={false}
        className="modalNoBtn information-modal"
        visible={visibleModalActivity}
        onCancel={handleCancel}
      >
        <h2 className="no-breadcrumb">Task Activity</h2>
        <div className="search-activity-response">
          <Input
            className={eventList.length > 0 ? 'search-log' : 'search-log-none'}
            prefix={<SearchOutlined />}
            value={searchTerm}
            onChange={onChangeSearch}
            placeholder="search activity"
            type="text"
            size="small"
            allowClear
          />
        </div>

        <div className="containerResponsModalActivity">{activityRenderBy_modal()}</div>
      </Modal>
      <Modal
        visible={isOpenModalDependencies}
        footer={false}
        onCancel={() => {
          setIsOpenModalDependencies(false)
          setDataModalDependencies([])
        }}
        width={744}
        centered
      >
        {modalDependencies()}
      </Modal>
      {modalReview()}
    </Container>
  )
}

export default Taskinboxdetail

const ContainerInModalDependencies = styled.div`
  .group-render-waiting {
    display: flex;
    column-gap: 8px;
    padding: 0px 10px 0px 10px;
    cursor: pointer;

    .dot {
      border: 3px solid black;
      border-radius: 50px;
      height: 1px;
      display: flex;
      align-self: center;
    }
  }

  .icon-leyout {
    text-align: center;
  }
  .text-title {
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    color: #074e9f;
    margin-top: 16px;
    margin-bottom: 16px;
    text-align: center;
  }
  .text-discraption {
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    margin-bottom: 16px;
    text-align: center;
  }
  .text-waitting {
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    color: #98a2b3;
    margin-bottom: 16px;
  }
`
